import { Box, styled } from '@mui/material';

export const DurationContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
  borderRadius: '4px',
  color: theme.palette.text.primary,
  cursor: 'pointer',
  display: 'flex',
  gap: theme.spacing(1),
  justifyContent: 'space-between',
  padding: theme.spacing(1.25),
  // Reset the native button it renders as when editable.
  border: 0,
  font: 'inherit',
  width: '100%',
  '&.readonly': {
    color: theme.palette.text.secondary,
    cursor: 'not-allowed',
  },
}));

export const ThumbnailContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

export const NoContentContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  justifyContent: 'center',
}));
